<!-- @file 移动端签到组件 -->

<template>
  <div class="plv-check-in-default plv-check-in-default__mobile">
    <check-in-list v-if="isShowList" :list="list" :check-in-sdk="checkInSdk"/>
    <div v-else class="plv-iar-check-in-default__content__mobile">
      <template v-if="isShowResult">
        <div class="plv-iar-check-in-default__success-bg">
          <img src="./imgs/check-in-success-bg.png" alt="" />
          <span>{{ iarTrans('checkIn.checkInSuccess')}}</span>
          <div style="width: 100%;">
            <div class="plv-iar-check-in-default__btn__wrap__mobile">
              <iar-button v-if="oldCheckInSocket"
                          class="plv-check-in-default__btn--record"
                          type="cancel"
                          @click="$emit('to-hide')">{{ iarTrans('checkIn.close') }}</iar-button>
              <iar-button v-else
                          class="plv-check-in-default__btn--record"
                          type="cancel"
                          @click="getCheckInInfo">{{ iarTrans('checkIn.record') }}</iar-button>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <countdown :duration="leftTime" class="plv-iar-check-in-default__downcount" />
        <p class="plv-check-in-default__content-message">{{ message }}</p>
        <p v-if="forceCheckInEnabled" class="plv-check-in-default__content-tip">{{ iarTrans('checkIn.checkInTip') }}</p>
        <div class="plv-iar-check-in-default__btn__wrap__mobile">
          <iar-button :disabled="disabled" @click="signIn">
            {{ iarTrans('checkIn.checkInBtn') }}
          </iar-button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import IarButton from '../../components/common/button/MobileButton';
import mixin from './mixin';
import CheckInList from '../../components/check-in/check-in-list/checkInList';
import Countdown from '../../components/check-in/countdown/countdown.vue';

export default {
  components: {
    CheckInList,
    IarButton,
    Countdown,
  },
  mixins: [mixin],
};
</script>

<style lang="scss">
.plv-check-in-default {
  height: 100%;
}
.plv-iar-check-in-default__content__mobile {
  margin-top: 46px;
  text-align: center;

  .plv-check-in-default__content-message {
    max-width: 350px;
    margin: 20px auto 68px;
    text-align: center;
    line-height: normal;
    word-break: break-all;
  }

  .plv-iar-check-in-default__downcount {
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;

    >span {
      font-size: 14px;
      color: #3082FE;
    }

    >span:nth-child(1) {
      font-size: 40px;
    }

    >span:nth-child(2) {
      margin: 20px 0 0 7px;
    }
  }

  >p {
    color: #333;
    font-size: 16px;
    margin: 0;
    margin-top: 20px;
  }

  .plv-check-in-default__content-tip {
    margin-top: -52px;
  }
}

.plv-check-in-default__mobile {
  .plv-iar-check-in-default__btn__wrap__mobile {
    padding: 0 24px;
    margin-top: 45px;
    text-align: center;
    .plv-iar-default-btn {
      border: 1px solid #2196F3;
    }
  }
  .plv-iar-check-in-default__success-bg {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      width: 140px;
      height: 140px;
      margin-bottom: 20px;
    }
    .plv-check-in-default__btn--record {
      color: #2196F3;
      margin-right: 0;
      background: white;
    }
  }
}
</style>
